import axios from 'axios';

const OSRM_BASE = 'https://router.project-osrm.org/route/v1/driving';

// 경로 캐시 (같은 좌표 조합은 한 번만 호출)
const cache = {};

const delay = (ms) => new Promise(r => setTimeout(r, ms));

export const getRoute = async (coords) => {
    const key = coords.map(c => `${c.lon.toFixed(5)},${c.lat.toFixed(5)}`).join(';');

    if (cache[key]) return cache[key];

    try {
        await delay(500); // 요청 간 500ms 간격 (OSRM 데모 서버 rate limit)
        const res = await axios.get(`${OSRM_BASE}/${key}?overview=full&geometries=geojson`);
        if (res.data.code === 'Ok' && res.data.routes.length > 0) {
            const route = res.data.routes[0];
            const result = {
                duration: Math.round(route.duration / 60),
                distance: Math.round(route.distance / 1000),
                geometry: route.geometry
            };
            cache[key] = result;
            return result;
        }
    } catch (e) {
        console.error('OSRM error:', e.message);
    }
    // 실패한 결과는 캐시하지 않음 (다음에 재시도)
    return null;
};
